// utils
import { axiosInstance as axios } from '../../utils/axios';

// ----------------------------------------------------------------------

export function getActivity() {
  return async () => {
    try {
      const response = await axios.get('/activity', {});
      return { success: true, data: response.data };
    } catch (error) {
      return { success: false, data: error };
    }
  };
}
